export const constants = {
  validation: {
    account: {
      displayName: {
        maxLength: 15,
      },
      accountId: {
        word: new RegExp(/^[a-zA-Z0-9_]*$/),
        maxLength: 20,
      },
      introduction: {
        maxLength: 1000,
      },
    },
    officialInformation: {
      title: {
        maxLength: 200,
      },
    },
    post: {
      resources: {
        min: 1,
        max: 10,
      },
    },
  },
  errorCodes: {
    /**
     * PrepaidPoint
     */
    INSUFFICIENT_PREPAID_POINT_BALANCE: 'INSUFFICIENT_PREPAID_POINT_BALANCE',
    INVALID_PREPAID_POINT_EXCHANGE_RATE: 'INVALID_PREPAID_POINT_EXCHANGE_RATE',
    /** メンバーシップに加入する必要があります */
    NEED_PATRON: 'NEED_PATRON',
    /** カードの有効期限が切れています */
    EXPIRED_CARD: 'EXPIRED_CARD',
    /** 3Dセキュア認証が必要です */
    REQUIRE_3D_SECURE: '3D_SECURE_REQUIRED',
    /** 何かしらの決済エラーです */
    PAYMENT_ERROR: 'STRIPE_CARD_ERROR',
    /** サブスクリプションがアクティブではありません */
    SUBSCRIPTION_PLAN_NOT_ACTIVE: 'SUBSCRIPTION_PLAN_NOT_ACTIVE',
  },
  storageKeys: {
    NAVIGATION_HISTORY: 'NAVIGATION_HISTORY',
    COMPLETED_GACHAS: 'COMPLETED_GACHAS',
    EVENT_MONTH: 'EVENT_MONTH',
    PARTNER_CLIENT_TOKEN_AUTH: 'PARTNER_CLIENT_TOKEN_AUTH',
  },
  httpHeaders: {
    /** ルート限定認証用のアクセストークン */
    X_UTONIQ_PARTNER_ACCESS_TOKEN: 'X-Utoniq-Partner-Access-Token',
    /** ルート限定認証用のクライアントID */
    X_UTONIQ_PARTNER_CLIENT_ID: 'X-Utoniq-Partner-Client-Id',
    /** LINE ミニアプリの本人確認用 ID トークン */
    X_UTONIQ_LINE_ID_TOKEN: 'x-utoniq-line-id-token',
    /** LINE ミニアプリのアクセストークン（サービスメッセージ・連動アプリ権限取消用） */
    X_UTONIQ_LINE_ACCESS_TOKEN: 'x-utoniq-line-access-token',
  },
  ui: {
    layout: {
      /** 画面幅 md 未満でトグル表示するサイドメニューの幅 */
      mobileSideMenuWidth: 304,
      /** 画面幅 md 以上で常時表示するサイドメニューの幅 */
      desktopSideMenuWidth: 300,
      /** レスポンシブ対応前のメインコンテンツの最大幅 */
      mainContentMaxWidth: 600,
    },
  },
} as const
